export const maybeAddSearchParam = (url, param, value) => {
  if (!url) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    if (value && urlObj.searchParams.get(param) !== value) {
      urlObj.searchParams.set(param, value);
    }
    return urlObj.toString();
  } catch (error) {
    return url;
  }
};